import { render, staticRenderFns } from "./inn.vue?vue&type=template&id=bf2b61fa&scoped=true&"
import script from "./inn.vue?vue&type=script&lang=js&"
export * from "./inn.vue?vue&type=script&lang=js&"
import style0 from "./inn.vue?vue&type=style&index=0&id=bf2b61fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2b61fa",
  null
  
)

export default component.exports